import script from "./PromptTuningDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptTuningDetail.vue?vue&type=script&setup=true&lang=js"

import "./PromptTuningDetail.vue?vue&type=style&index=0&id=9a1dcc66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a1dcc66"]])

export default __exports__